import { refreshRotateControl } from './refreshRotateControl.js';

export function refreshRotateFocus() {
  refreshRotateControl.call(this._rotateControl);
}
